export default "__VITE_PUBLIC_ASSET__576005b1__"